// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/accumulation_buffer.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'accumulation_bufferPixelShader';
const shader = `#ifdef GL_ES
#endif
precision highp float;
varying vec2 vUV;
#ifdef USE_EXACT_SRGB_CONVERSIONS
#undef USE_EXACT_SRGB_CONVERSIONS
#endif
#include <helperFunctions>
uniform highp sampler2D textureSampler;
uniform highp sampler2D previousFrames;
uniform float accumulationBlend;
#ifdef ENABLE_TONEMAPPING
vec3 tonemap(vec3 color);
#endif
#ifdef ENABLE_BLOOM
vec3 getBloom();
#else
vec3 getBloom() { return vec3(0.0); }
#endif
#ifdef ENABLE_LUT
uniform highp sampler2DArray lutSampler;
#endif
const float VIEWER_GAMMA = 2.2;
void main(void)
{
vec4 currentFramePixelValue = texture2D(textureSampler, vUV);
#ifndef ENABLE_TONEMAPPING
currentFramePixelValue.rgb = pow(currentFramePixelValue.rgb, vec3(VIEWER_GAMMA));
#endif
currentFramePixelValue.rgb += getBloom();
#ifdef ENABLE_TONEMAPPING
currentFramePixelValue.rgb = tonemap(currentFramePixelValue.rgb);
#endif
currentFramePixelValue.rgb = clamp(currentFramePixelValue.rgb, 0.0, 1.0);
currentFramePixelValue.rgb = pow(currentFramePixelValue.rgb, vec3(1.0 / VIEWER_GAMMA));
#ifdef ENABLE_LUT
float lutDepth = float(textureSize(lutSampler, 0).r);
float lutLayer = (lutDepth - 1.0) * currentFramePixelValue.b;
float inverseLutDepth = 1.0 / lutDepth;
vec2 lutUV = currentFramePixelValue.rg * (1.0 - inverseLutDepth) + vec2(0.5 * inverseLutDepth);
vec3 lutA = texture(lutSampler, vec3(lutUV, floor(lutLayer))).rgb;
vec3 lutB = texture(lutSampler, vec3(lutUV, floor(lutLayer) + 1.0)).rgb;
currentFramePixelValue.rgb = mix(lutA, lutB, fract(lutLayer));
#endif
vec4 accumulatedPixelValue = texture2D(previousFrames, vUV);
gl_FragColor = mix(accumulatedPixelValue, currentFramePixelValue, accumulationBlend);
}
#ifdef ENABLE_TONEMAPPING
const mat3 ACESInputMat = mat3(
vec3(0.59719, 0.07600, 0.02840),
vec3(0.35458, 0.90834, 0.13383),
vec3(0.04823, 0.01566, 0.83777)
);
const mat3 ACESOutputMat = mat3(
vec3( 1.60475, -0.10208, -0.00327),
vec3(-0.53108,  1.10813, -0.07276),
vec3(-0.07367, -0.00605,  1.07602)
);
vec3 RRTAndODTFit(vec3 v)
{
vec3 a = v * (v + 0.0245786) - 0.000090537;
vec3 b = v * (0.983729 * v + 0.4329510) + 0.238081;
return a / b;
}
vec3 tonemap(vec3 color)
{
color = RRTAndODTFit(color);
color = ACESOutputMat * color;
return color;
}
#endif
#ifdef ENABLE_BLOOM
uniform mediump sampler2D bloomSampler[BLOOM_LEVELS_COUNT];
uniform float bloomIntensity;
vec3 getBloom() {
if (bloomIntensity == 0.0) return vec3(0.0);
const vec3 weights = vec3(0.25, 0.5, 2.5);
vec3 bloom;
bloom = texture2D(bloomSampler[0], vUV).rgb * weights[0];
bloom += texture2D(bloomSampler[1], vUV).rgb * weights[1];
bloom += texture2D(bloomSampler[2], vUV).rgb * weights[2];
return (bloomIntensity / dot(weights, vec3(1.0))) * bloom;
}
#endif
`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const accumulation_bufferPixelShader = { name, shader };
//# sourceMappingURL=accumulation_buffer.fragment.js.map